import axios from "axios";
// Vector Logger API
const axiosInstanceVectorLogger = axios.create({
  baseURL: "https://fs3ihuvuhc.execute-api.ap-northeast-2.amazonaws.com",
  headers: {
    "Content-Type": "application/json",
    // Include the JWT token in the Authorization header
    // Replace 'token' with the actual token you have stored
    "X-API-Key": "logger_key_1",
  },
});

const apiCallVectorLogger = {
  get(url, params = {}) {
    return axiosInstanceVectorLogger.get(url, { params });
  },
  post(url, data = {}) {
    return axiosInstanceVectorLogger.post(url, data);
  },
  patch(url, data = {}) {
    return axiosInstanceVectorLogger.patch(url, data);
  },
  delete(url) {
    return axiosInstanceVectorLogger.delete(url);
  },
  put(url, data = {}) {
    return axiosInstanceVectorLogger.put(url, data);
  },
};

export default apiCallVectorLogger;
